import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { myBookings } from "../api/api";
import { environment } from "../../environments/environments";
import moment from "moment";
import "./Booking.css"; // <-- CSS file

const Booking = () => {
  const navigate = useNavigate();
  const [booking, setBooking] = useState([]);
  const [loading, setLoading] = useState(true);

  const formatRole = (role) => {
    switch (role) {
      case "match_success_advisor":
        return "Match Success Advisor";
      case "connection_curator":
        return "Connection Curator";
      case "match_making_consultant":
        return "Match Making Consultant";
      case "relationship_success_coach":
        return "Relationship Success Coach";
      default:
        return role?.replace(/_/g, " ");
    }
  };

  useEffect(() => {
    const fetchCounsellors = async () => {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      const userId = userData?.id || userData?._id;

      try {
        const response = await myBookings({ user_id: userId });
        // console.log("response_booking", response.data);
        console.log("First booking status:", response.data);

        setBooking(response.data || []);
      } catch (error) {
        console.error("Error fetching bookings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCounsellors();
  }, []);

  if (loading) {
    return (
      <div className="booking-loader-container">
        <div className="booking-spinner" />
      </div>
    );
  }

  return (
    <div className="booking-container">
      {booking.length === 0 ? (
        <div className="booking-no-booking">
          <h2 className="booking-no-text">No Booking Available</h2>
        </div>
      ) : (
        booking?.map((item) => {
          const imageUrl = `${environment.url}/uploads/counsellors/${item?.counsellor?.image}`;
          return (
            <div
              key={item?.id}
              className="booking-card"
              onClick={() => {
                navigate(`/Sidebar/BookingDetails/${item?.id}`, {
                  state: {
                    id: item?.id,
                    status: item?.status,
                    counsellor_id: item?.counsellor_id,
                  },
                });
              }}
            >
              {item?.status === "0" && (
                <div className="booking-expiry-badge">
                  <span className="booking-expiry-text">Booking Expired</span>
                </div>
              )}
              <img src={imageUrl} alt="counsellor" className="booking-avatar" />
              <div className="booking-info">
                <h3 className="booking-name">{item?.counsellor?.name}</h3>
                <p className="booking-role">
                  {formatRole(item?.counsellor?.role)}
                </p>
                <p className="booking-role">{item?.time}</p>
                <p className="booking-role">
                  {moment(item?.date).format("D MMMM YYYY")}
                </p>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default Booking;
